import { createFileRoute } from '@tanstack/react-router';
import { TenantDetailRoute } from '@/pages/tenants/detail-route';

/** Deep link al dettaglio: la lista sta già sotto, montata dal layout. */
export const Route = createFileRoute('/referrer/_layout/tenants/_layout/$id')({
  component: TenantDetailRouteComponent,
});

function TenantDetailRouteComponent() {
  const { id } = Route.useParams();

  return <TenantDetailRoute tenantId={id} />;
}
